// @flow

import Resource from 'speed-js-core/src/api/Resource';
import OrganisationalUnitResource from 'esm-web-pro/api/resources/OrganisationalUnitResource';

export default class OrganisationResource extends Resource {
    basePath: string = 'entities/organisations/';

    objectPath: string = 'entities/organisations/{ident}/';

    nestedResources = {
        units: OrganisationalUnitResource,
    };

    units: OrganisationalUnitResource;

    sync(): Promise<Object> {
        return this.client._request('entities/organisations/sync_units/', 'GET');
    }
}
